const WIDGETS_OVERLAY_MIN_CONSTRAINTS = {
  width: 350,
  height: 350,
};

export default WIDGETS_OVERLAY_MIN_CONSTRAINTS;
